import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signupUser } from '../features/auth/authAPI';
import { useNavigate } from "react-router-dom";
//import Modal from '../components/Modal/popup'
import "./SignupPage.css";

export default function SignupPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const modalMessage = useSelector((state) => state.signup.status)
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    country: "",
    phone: "",
    agreeToTerms: false,
  });

useEffect(() => {
      if (token) {
        navigate('/protected');
      }
    }, [navigate, token]);

    const Redirect = () => {
      // Clear the modal message
      navigate('/login');
    };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agreeToTerms) {
      alert("You must agree to the Terms & Privacy Policy.");
      return;
    }

    dispatch(signupUser({formData})).then((action) => {
      if (action.type === "auth/signupUser/fulfilled") {
        navigate("/login");
      }
    });
  };

  return (
    <div className="signup-container">
      <form className="signup-box" onSubmit={handleSubmit}>
        <div className="input-group">
          <div>
            <label>First Name</label>
            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
          </div>
          <div>
            <label>Last Name</label>
            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
          </div>
        </div>

        <div className="input-group">
          <div>
            <label>Email address <span className="required">*</span></label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div>
            <label>Password <span className="required">*</span></label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} required />
          </div>
        </div>

        <div className="input-group">
          <div>
            <label>Country</label>
            <select name="country" value={formData.country} onChange={handleChange} required>
              <option value="">Select a country...</option>
              <option value="USA">USA</option>
              <option value="Canada">Canada</option>
              <option value="UK">UK</option>
              <option value="India">India</option>
            </select>
          </div>
          <div>
            <label>Phone</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
          </div>
        </div>

        <div className="terms">
          <input type="checkbox" name="agreeToTerms" checked={formData.agreeToTerms} onChange={handleChange} />
          <label>
            By providing your contact details, you agree to our{" "}
            <a href="#">Terms of Use & Privacy Policy</a>
          </label>
        </div>

        <button type="submit" className="register-button">Register</button>
      </form>
	    {/* <Modal message={modalMessage} onClose={Redirect} action={"Click to Login"}/> */}
    </div>
  );
}
